import {
  Box,
  CardContent,
  CardHeader,
  Chip,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  IconCalculator,
  IconPresentation,
  IconChartLine,
  IconChevronRight,
  IconReportMoney,
  IconTimelineEvent,
} from "@tabler/icons-react";
import { getDoc } from "firebase/firestore";
import moment from "moment";
import { useEffect, useState } from "react";
import UsuarioDb from "../../../../db/usuarioDb";
import Usuario from "../../../../models/usuario";
import { useUsuario } from "../../../../providers/usuarioProvider";
import PermissaoDisplay from "../../../util/permissaoDisplay";
import FelixCard from "../../../util/ui/felixCard";
import Blink from "../../../util/ui/blink";
import { Link } from "react-router-dom";

export default function Calculos() {
  const [usuario, setUsuario] = useState<Usuario>();
  const { visualizado } = useUsuario();

  useEffect(() => {
    if (!!visualizado) {
      getDoc(new UsuarioDb().doc({ usuarioId: visualizado })).then((doc) =>
        setUsuario(doc.data())
      );
    }
  }, [visualizado]);

  const corBlink = (usuario?: Usuario) => {
    const atrasado = !!usuario?.atualizadoAte?.isBefore(
      moment.tz("America/Sao_Paulo"),
      "day"
    );
    const semCalculo = !usuario?.estatisticas?.impostos;
    if (semCalculo) {
      return "error";
    } else {
      if (!atrasado) {
        return "success";
      } else {
        return "warning";
      }
    }
  };

  const getMensagem = (key: string, usuario?: Usuario) => {
    const atrasado = !!usuario?.atualizadoAte?.isBefore(
      moment.tz("America/Sao_Paulo"),
      "day"
    );
    const descalculado = !usuario?.estatisticas?.impostos;
    switch (key) {
      case "mensal":
        if (descalculado) {
          return (
            <Typography variant="body2" color="text.secondary">
              Clique aqui para iniciar seus cálculos.
            </Typography>
          );
        } else if (atrasado) {
          return (
            <Typography variant="body2" color="text.secondary">
              Cálculos desatualizados desde{" "}
              {/* Data em mono tabular, mesmo dentro da frase. */}
              <Typography
                variant="dataMono"
                component="span"
                fontSize="inherit"
              >
                {usuario?.atualizadoAte.format("DD/MM/YYYY")}
              </Typography>
              .
            </Typography>
          );
        } else {
          return (
            <Typography variant="body2" color="text.secondary">
              Cálculos em dia.
            </Typography>
          );
        }
    }
  };

  return (
    <FelixCard className="calculos">
      <CardHeader
        title="Seus cálculos"
        avatar={<IconCalculator size={16} />}
      />
      <CardContent>
        <List sx={{ padding: 0 }}>
          <PermissaoDisplay
            match={(claims) => !!claims?.permissoes?.ver_timeline}
          >
            <ListItemButton
              key="mensal"
              dense
              disableGutters
              sx={{ borderRadius: 1 }}
              component={Link}
              to="/timeline"
            >
              <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
                <Blink color={corBlink(usuario)} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Chip
                      color="primary"
                      icon={<IconTimelineEvent />}
                      size="medium"
                      label="Timeline"
                    />
                    <Box paddingRight={1} />
                    {getMensagem("mensal", usuario)}
                    <Box flexGrow={1} />
                    <Icon color="action">
                      <IconChevronRight />
                    </Icon>
                  </Box>
                }
              />
            </ListItemButton>
          </PermissaoDisplay>
          <PermissaoDisplay
            match={(claims) => !!claims?.permissoes?.ver_relatorios}
          >
            <ListItemButton
              key="declaração"
              dense
              disableGutters
              sx={{ borderRadius: 1 }}
              component={Link}
              to="/declaracao"
            >
              <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
                <Blink
                  color={usuario?.estatisticas?.impostos ? "success" : "error"}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Chip
                      color="primary"
                      icon={<IconReportMoney />}
                      size="medium"
                      label="Declaração"
                    />
                    <Box flexGrow={1} />

                    <Icon color="action">
                      <IconChevronRight />
                    </Icon>
                  </Box>
                }
              />
            </ListItemButton>
          </PermissaoDisplay>
          <ListItemButton
            key="análises"
            dense
            disableGutters
            sx={{ borderRadius: 1 }}
            component={Link}
            to="/analises"
          >
            <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
              <Blink
                color={usuario?.estatisticas?.impostos ? "success" : "error"}
              />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Chip
                    color="primary"
                    icon={<IconPresentation />}
                    size="medium"
                    label="Análises"
                  />
                  <Box flexGrow={1} />

                  <Icon color="action">
                    <IconChevronRight />
                  </Icon>
                </Box>
              }
            />
          </ListItemButton>
          <ListItemButton
            key="rentabilidade"
            dense
            disableGutters
            sx={{ borderRadius: 1 }}
            component={Link}
            to="/rentabilidade"
          >
            <ListItemIcon style={{ minWidth: 40, justifyContent: "center" }}>
              <Blink
                color={usuario?.estatisticas?.impostos ? "success" : "error"}
              />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Chip
                    color="primary"
                    icon={<IconChartLine />}
                    size="medium"
                    label="Rentabilidade"
                  />
                  <Box flexGrow={1} />

                  <Icon color="action">
                    <IconChevronRight />
                  </Icon>
                </Box>
              }
            />
          </ListItemButton>
        </List>
      </CardContent>
    </FelixCard>
  );
}
